import React from 'react';
import { motion } from 'framer-motion';
interface CursorProps {
  x: number;
  y: number;
  /** Increment to fire a click ripple at the current position. */
  clickId?: number;
  visible?: boolean;
}

/**
 * Realistic pointer used on the "traditional website" slides. Movement is
 * spring-driven so it eases into targets the way a real hand does, and each
 * click emits a single soft ripple instead of a bouncy scale animation.
 */
export function Cursor({
  x,
  y,
  clickId = 0,
  visible = true
}: CursorProps) {
  return <motion.div className="absolute top-0 left-0 z-40 pointer-events-none" initial={false} animate={{
    x,
    y,
    opacity: visible ? 1 : 0
  }} transition={{
    x: {
      type: 'spring',
      stiffness: 85,
      damping: 17,
      mass: 0.8
    },
    y: {
      type: 'spring',
      stiffness: 85,
      damping: 17,
      mass: 0.8
    },
    opacity: {
      duration: 0.2,
      ease: 'easeOut'
    }
  }} data-id="element-1727" data-mp="1mw8p4iyblaxu">
      {clickId > 0 && <motion.span key={clickId} className="absolute -top-2 -left-2 w-8 h-8 rounded-full bg-primary-indigo/25" initial={{
      scale: 0.2,
      opacity: 0.55
    }} animate={{
      scale: 1.9,
      opacity: 0
    }} transition={{
      duration: 0.45,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-1728" data-mp="13zqv1uw00yyf" />}
      <motion.svg width="20" height="26" viewBox="0 0 20 26" fill="none" animate={{
      scale: clickId > 0 ? [1, 0.88, 1] : 1
    }} transition={{
      duration: 0.18,
      ease: 'easeOut'
    }} style={{
      filter: 'drop-shadow(0 3px 6px rgba(11,18,32,0.35))'
    }} data-id="element-1729" data-mp="3dgqc7nrbg3mz">
        <path d="M2 1.5 17 12.2l-6.3.6 3.5 7.4-2.7 1.3-3.5-7.4L4 18.7 2 1.5Z" fill="#fff" stroke="#0B1220" strokeWidth="1.4" strokeLinejoin="round" data-id="element-1730" data-mp="dyz263zhmd0l" />
      </motion.svg>
    </motion.div>;
}